import SellerOnboardingStandardInitializer from '@psl/flows/seller-onboarding/initializers/standard';
import { memo, Suspense } from 'react';

export const SellerOnboardingInitializer = memo(() => {
  return (
    <Suspense fallback={null}>
      <SellerOnboardingStandardInitializer />
    </Suspense>
  );
});
